import React from "react";
import { compose } from "recompose";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";

class ContactUsComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t , r} = this.props;
        let  src = '/assets/img/front/icons/phone-circle-'+this.props.iconColor+'.svg';
        return (
            <div className="relative">
                <a href={r('content_contact')} className="flex font-w600 font-120 blue1" >
                    <img alt="phone" className="mr-2" src={(this.props.searchURLBase ? this.props.searchURLBase : '') + src} height={this.props.height} width={this.props.width}/>
                    <span>{t('contactus')}</span>
                </a>
            </div>
        );
    }
}

export const ContactUs = compose(
    withTranslator,
    withFosRouter
)(ContactUsComponent);